import { dew as _indexDew } from "../../utils/index.js";
import { dew as _verifyHashDew } from "./verifyHash.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.verifyMessage = void 0;
  const index_js_1 = _indexDew();
  const verifyHash_js_1 = _verifyHashDew();
  async function verifyMessage(client, {
    address,
    message,
    signature,
    ...callRequest
  }) {
    const hash = (0, index_js_1.hashMessage)(message);
    return (0, verifyHash_js_1.verifyHash)(client, {
      address,
      hash,
      signature,
      ...callRequest
    });
  }
  exports.verifyMessage = verifyMessage;
  //# sourceMappingURL=verifyMessage.js.map
  return exports;
}